import React, {useEffect, useState} from "react";
import OrdersPendingComponent from "./OrdersPendingComponent";
import {useWebsocketStore} from "../../../../stores/websocketStore/websocketProvider";

export default function DisplayOrdersPending({}) {// extends React.Component {
    const {orderPendingSubject} = useWebsocketStore();
    const [msg, setMsg] = useState({});
    useEffect(() => {
        const subscription = orderPendingSubject.subscribe(setMsg);
        return () => subscription.unsubscribe();
    }, []);
    /*componentDidMount() {
        this.subscription = orderPendingSubject.subscribe((msg) => this.setState({msg: msg}))
    }*/

    return <OrdersPendingComponent ordersPendingMsg={msg}/>;
}